import { HttpTypes } from "@medusajs/types"
import { clx } from "@modules/common/components/ui"
import React from "react"

type OptionSelectProps = {
  option: HttpTypes.StoreProductOption
  current: string | undefined
  updateOption: (title: string, value: string) => void
  title: string
  disabled: boolean
  "data-testid"?: string
}

const OptionSelect: React.FC<OptionSelectProps> = ({
  option,
  current,
  updateOption,
  title,
  "data-testid": dataTestId,
  disabled,
}) => {
  const filteredOptions = (option.values ?? []).map((v) => v.value)

  return (
    <div className="flex flex-col gap-y-2">
      <span className="text-sm text-ui-fg-subtle">
        {title}
        {current && (
          <span className="text-ui-fg-base font-medium">: {current}</span>
        )}
      </span>
      {/*
        Antes esto era `flex-wrap justify-between` con `flex-1` en cada boton:
        con 5 tallas el ancho se reparte a ~54 px por boton y cualquier etiqueta
        algo larga se sale y pisa el precio. Ahora cada boton se dimensiona por
        su contenido y la fila se envuelve sola.
      */}
      <div className="flex flex-wrap gap-2" data-testid={dataTestId}>
        {filteredOptions.map((v) => {
          const isSelected = v === current
          return (
            <button
              onClick={() => updateOption(option.id, v)}
              key={v}
              className={clx(
                "border text-small-regular min-h-10 min-w-[3.5rem] rounded-rounded px-3 py-2 text-center transition-colors duration-150",
                {
                  "border-ui-fg-base ring-1 ring-ui-fg-base bg-ui-bg-base font-medium":
                    isSelected,
                  "border-ui-border-base bg-ui-bg-subtle hover:border-ui-fg-muted":
                    !isSelected,
                  "opacity-50 cursor-not-allowed": disabled,
                }
              )}
              disabled={disabled}
              aria-pressed={isSelected}
              data-testid="option-button"
            >
              {v}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default OptionSelect
